import { makeStyles } from '@material-ui/core/styles';
import { TextColors } from '@/utils/constants';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {},
    title: {
      color: TextColors.dark,
      margin: 0,
      display: 'flex',
      alignItems: 'baseline',
      marginBottom: muiTheme.spacing(0.2),
      justifyContent: 'space-between',
      lineHeight: `${muiTheme.spacing(10)}px`,
    },
    partnerOnlyFilter: {
      marginBottom: muiTheme.spacing(3),
    },
    filters: {
      width: '100%',
      '& .filter-checkbox': {
        flex: '0 0 100%',
        width: '100%',
      },
    },
  }),
  { name: 'GenSearchResultsSidebar' },
);

export default useStyles;
